import { useIsPeopleUnlockButtonLoading } from '@aibees/elephant/components/people-unlock/hooks/use-is-people-unlock-button-loading';
import { ProfileDetailsNoData } from '@aibees/elephant/components/profile-details-no-data';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import { Scrollbar } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { ContactDetailItemHeader } from '../../../contact-detail-item-header';
import { useContactDetailsState } from '../../context';
import { useSetSeemoreVisibility } from '../../hooks/use-set-seemore-visibility';
import * as EXTERNALSX from '../../sx';
import { doesContactDetailHaveUpdate } from '../../utils';
import { CertificationItem } from './components/certification-item';
import * as SX from './sx';
import type { CertificationProps as Props } from './types';

export const Certification = memo(
  ({ className, itemsLimit, setShowSeeMore }: Props) => {
    const { api } = usePersonReadDataContext();
    useSetSeemoreVisibility(
      setShowSeeMore,
      itemsLimit,
      api.data?.certifications?.length
    );
    const { loadingContactDetails } = useIsPeopleUnlockButtonLoading(api.data);
    const { unlocked, isPopoverType } = useContactDetailsState();
    const hasUpdate = doesContactDetailHaveUpdate(
      PersonContactDetailsItem.CERTIFICATIONS,
      api.data
    );

    const content = (
      <Stack direction="column" gap={1}>
        {hasUpdate && api.data?.certifications?.[0] && (
          <div
            key={-1}
            style={{
              filter: 'blur(4px)',
            }}
            onClick={(e) => e.preventDefault()}
          >
            <CertificationItem
              key={-1}
              item={api.data?.certifications?.[0]}
              index={-1}
            />
          </div>
        )}
        {api.data?.certifications?.map((item, index) => {
          if (!!itemsLimit && index >= itemsLimit) return null;
          return <CertificationItem key={index} item={item} index={index} />;
        })}
      </Stack>
    );

    return (
      <Box className={classnames('Certification', className)} sx={SX.root}>
        <ContactDetailItemHeader
          title="Licenses & Certifications"
          count={api.data?.certifications?.length ?? 0}
        />
        {!unlocked || loadingContactDetails ? (
          <ProfileDetailsNoData />
        ) : isPopoverType ? (
          <Scrollbar sx={EXTERNALSX.generalProfileDetailsScrollbar}>
            {content}
          </Scrollbar>
        ) : (
          content
        )}
      </Box>
    );
  }
);

Certification.displayName = 'Certification';
